/**
 * created by lei lei on 2020/6/15
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CustomTable, {TitleIcon} from './CustomTable'
import {Table} from "antd";

export default class CustomTableComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const dataSource = [
            {
                key: '1',
                name: '胡彦斌大叔大婶大萨多撒大萨阿斯达阿萨德撒所sad按时按时assay啊实打实阿斯达啊实打实阿斯达啊实打实阿斯达按时大萨sad啊实打实',
                age: 32,
                address: '西湖区湖底公园1号',
            },
            {
                key: '2',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '3',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '4',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }
            , {
                key: '5',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '5',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '5',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '5',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '5',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '5',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            }, {
                key: '5',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            },
        ];

        let titleKeyList =
            [{
                key: 'name',
                titleName: '名称',
                width: 500,
                align: 'center',
                ellipsis: true,
            },
                {
                    key: 'age',
                    titleName: '年龄',
                    width: 300,
                    align: 'left',
                    render: (text, record, index) => {
                        return (<div>
                                <TitleIcon iconType={'weChat'}/>
                            </div>

                        )
                    }
                },
                {
                    key: 'address',
                    titleName: '地址',
                    width: '20%',
                    render: (text, record, index) => {
                        return (<div>
                                <TitleIcon title={record.address} iconType={'microBlog'}/>
                            </div>

                        )
                    }
                },];


        return (
            <div>
                <CustomTable
                    dataSource={dataSource}
                    titleKeyList={titleKeyList}
                    //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                    pagination={{
                        showQuickJumper: true,
                        total: dataSource.length,
                        onChange: (e) => {
                            console.log('onchange', e)
                        },
                        style: {marginRight: '20px'},
                        showTotal: total => `共 ${total} 条数据`,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '30', '40'],
                        position: 'bottom'//这个版本目前只支持上下，不支持bottomLeft
                    }}
                    onRow={(record, index) => {
                        return {
                            onClick: event => {
                                console.log('onclickItem', record, index)
                            }, // 点击行
                            onDoubleClick: event => {
                            },
                            onContextMenu: event => {
                            },
                            onMouseEnter: event => {
                            }, // 鼠标移入行
                            onMouseLeave: event => {
                            },
                        };
                    }}
                    locale={{emptyText: '暂无数据'}}

                />
            </div>
        )
    }

}